import * as yup from 'yup'

export const socialMediaRegexErrorMessage =
  'Only letters, numbers, underscores and dots are allowed. Spaces are not allowed.'

export const attributeShape = {
  type: yup.string().required(),
  category: yup.string().required(),
  value: yup.mixed().nullable(),
}

export const supportValidationSchema = yup.object().shape({
  email: yup
    .string()
    .email('Must be a valid email address')
    .required('Please provide an email address where we can reach you'),
  topic: yup
    .object()
    .shape({
      value: yup.number().required(),
      label: yup.string().required(),
    })
    .required('Please select a topic'),
  question: yup
    .string()
    .min(1, 'Please describe your question')
    .max(500, 'Question should be at max 500 chars long.'),
  attachmentUrl: yup.string().optional(),
})

export type SupportPayload = yup.InferType<typeof supportValidationSchema>
